import type { GetServerSidePropsContext } from "next";

import { loadPageWithGlobal } from "@shared/api";

import { getHomePage, HomePage, type HomePageType } from "@/_pages/home";

type PageProps = {
  cms: HomePageType;
};

const Page = (props: PageProps) => {
  const { cms } = props;

  return <HomePage data={cms} />;
};

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  return await loadPageWithGlobal(async () => {
    return {
      ...(await getHomePage()),
    };
  }, ctx);
}

export default Page;
